module.exports = __webpack_public_path__ + "img/ic-mode-autorenew.dd1390af.svg";